import React from 'react'
import { ThemeHeading } from '../../components/common/ThemeHeading'
import ProjectsData from '../../data/projects'
import Masonry from 'react-masonry-component'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExpandArrowsAlt } from '@fortawesome/free-solid-svg-icons'

const masonryOptions = {
   transitionDuration: 0
}

const imagesLoadedOptions = {
   background: '.my-bg-image-el'
}

export default function Projects(props) {
   const [open, setOpen] = React.useState()
   const [projects, setProjects] = React.useState(ProjectsData)

   const previewImage = (image) => {
      setOpen(image)
   }

   const closePreviewImage = () => {
      setOpen(null)
   }

   const filterProject = (e, item) => {
      var elems = document.querySelectorAll(".portfolio");
      [].forEach.call(elems, function (el) {
         el.classList.remove("active");
      });
      e.target.classList.add('active')

      if (item !== 'all') {
         const data = ProjectsData.filter(function (list) {
            return list.category.toLowerCase().search(
               item.toLowerCase()) !== -1;
         });
         setProjects(data)
      } else {
         setProjects(ProjectsData)
      }
   }

   const childElements = projects.map(function (data, i) {
      return (
         <div key={i} className={"col-lg-4 col-sm-6 iteams " + props.Category}>
            <div className="project-iteam-content">
               <img src={data.image} alt="" title="" />
               <div className="project-iteam-hover">
                  <div className="project-iteam-icon">
                     <FontAwesomeIcon icon={faExpandArrowsAlt} onClick={() => previewImage(data.image)} />
                  </div>
                  <div className="project-iteam-dec">
                     <h6>{data.title}</h6>
                     <span>{data.description}</span>
                  </div>
               </div>
            </div>
         </div>
      );
   });

   return (
      <React.Fragment>
         <section className="project-wrapper site-margin wow bounceInUp" data-wow-duration="1s" data-wow-delay="0.10s"
            id="project">
            <div className="container">
               <div className="project-first-block">

                  <ThemeHeading
                     heading="My Creative ideas"
                  />
                  <div className="project-portfolio-filter portfolioFilter text-center" id="filter">
                     <ul>
                        <li className="portfolio active" onClick={(e) => filterProject(e, 'all') } >All</li>
                        <li className="portfolio" onClick={(e) => {filterProject(e, 'design')}} >Web Design</li>
                        <li className="portfolio" onClick={(e) => filterProject(e, 'graphics')} >graphics</li>
                        <li className="portfolio" onClick={(e) => filterProject(e, 'video')} >video</li>
                     </ul>
                  </div>
               </div>
               <div className="project-second-block ">
                  
                     <Masonry
                        className={'my-gallery-class'}
                        elementType={'ul'}
                        options={masonryOptions}
                        disableImagesLoaded={false}
                        updateOnEachImageLoad={false}
                        imagesLoadedOptions={imagesLoadedOptions}
                     >
                        {childElements}
                     </Masonry>
               </div>
            </div>
         </section>
         {open ?
            <div className="zoomImage">
               <span className="zoomColse" onClick={() => closePreviewImage()}></span>
               <img src={open} id="previewImage" alt="" title="" />
            </div>

            : ''}
      </React.Fragment>
   )
}